<template>
  <div class='wrapper'>
    <p>若您需要完整使用山东一卡通APP全部服务，需阅读并同意《用户协议》与《隐私政策》。</p>

    <p>如果您只想先行浏览APP首页内容、查看整体布局，暂时不愿同意协议政策，可选择进入游客模式。</p>

    <p>游客模式下，山东一卡通仅为保障系统安全稳定运行、履行法定义务，依照法律法规收集最小必要信息，仅包含网络基础信息（网络类型、IP
      地址等）、设备基础标识信息、应用版本信息，不会额外采集手机号、身份信息、消费信息等隐私数据。</p>

    <p>游客模式为未登录、未同意协议的临时浏览状态，仅开放首页预览查看权限：</p>

    <ol>
      <li>1、仅能浏览首页页面内容，无法使用充值消费、账单查询、权益兑换、线上客服、生活便民等核心业务功能；</li>
      <li>2、如需使用任意业务功能，系统将会自动跳转，引导您完成「同意用户服务协议 &amp;
        隐私政策」或拉起登录页面完成账号登录，核验授权后方可正常使用对应功能；
      </li>
      <li>3、游客模式全程不会主动收集非必要个人隐私信息，保障您浏览阶段的信息安全。</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'GuestMode',
  data() {
    return {}
  },
  created() {
  },
  methods: {}
}
</script>

<style scoped lang='scss'>
.wrapper {
  background-color: white;
  min-height: 100vh;
  box-sizing: border-box;
  font-size: 0.15rem;
  text-align: left;
  color: #333333;
  line-height: 1.8;
  padding: 0.16rem 0.14rem;

  p {
    margin-bottom: 0.1rem;
    text-indent: 0.3rem;
  }

  ol {
    padding-left: 0.12rem;
    margin-bottom: 0.14rem;

    li {
      margin-bottom: 0.1rem;
    }
  }
}
</style>
